
import { Component, Vue } from "vue-property-decorator";

import "@/assets/css/pages/policy.css";

@Component
export default class extends Vue {}
